export function cn(...args: (string | Record<string, boolean> | undefined | null | false)[]): string {
  return args
    .flatMap((arg) => {
      if (typeof arg === 'string') {
        return arg.trim();
      }
      if (Array.isArray(arg)) {
        return cn(...arg);
      }
      if (arg && typeof arg === 'object') {
        return Object.keys(arg).filter((key) => arg[key]);
      }
      return [];
    })
    .filter(Boolean) // Remove falsy values
    .join(' ');
}
